<template>
    <div class="flag-icon" :style="{backgroundImage: `url(${asset})`}"/>
</template>

<script>
export default {
    name: "Flag",
    props: {
        countryCode: String
    },
    computed: {
        asset() {
            return require(`../../../assets/images/lang/${this.countryCode}.png`)
        }
    }
}
</script>

<style scoped>
    .flag-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;

        background-size: cover;
        background-position: center center;
        border-radius: 10px;

        display: inline-block;
    }
</style>